import { constantsJson } from "@corca/data";

import { appendLatexKeywords } from "./utils/appendLatexKeywords";
import { normalizeSuggestionKeywords } from "./utils/normalizeKeywords";
import { greekLetterVariables } from "./utils/symbolLookup";
import { valueNodeSuggestionsProvider } from "./valueNodeSuggestionsProvider";

import type { SuggestionItem, SingleSuggestion } from "../types";

export const constants: SingleSuggestion<"constant">[] = constantsJson.map((s) => ({
  type: "single",
  item: {
    ...s,
    type: "constant",
    keywords: appendLatexKeywords(s.symbolProps?.key, normalizeSuggestionKeywords(s)),
    intlName: "constant",
    displayName: s.name,
    props: s.props as SuggestionItem<"constant">["props"],
    labels: s.labels,
  },
  context: (s.context as ("single" | "multi")[]) ?? ["single", "multi"],
  priority: 1.1,
  popupGroup: s.popupGroup,
}));

/**
 * The Greek letters only feed the new-node path, which stays typed: `skipSymbol` keeps them out
 * of the rows, and `alpha` still offers a new constant α.
 */
export const constantSuggestionsProvider = valueNodeSuggestionsProvider(
  "constant",
  (doc) => [
    ...(doc.libraries.serves("constants.json") ? [] : constants),
    ...(doc.libraries.serves("symbols.json") ? [] : greekLetterVariables),
  ],
  { skipSymbol: true, symbolFilter: ({ item }) => item.category === "Greek alphabet" },
);
